module.exports = __webpack_public_path__ + "static/media/logo_purple_title.53d0471b.svg";